import {
  type GetSalaryHistoryAPIResponse,
  salaryHistoryNamespace,
} from '@omnipresentgroup/types';

export const selectSalaryHistory = (
  salaryHistoryAPIResponse: GetSalaryHistoryAPIResponse,
) => salaryHistoryAPIResponse[salaryHistoryNamespace];
